import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getRoles = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/roles/lookup`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Roles fetch error:", error);
    throw error;
  }
};

const getFuelVendorProfile = async (config = {}) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/profile/`,
      {
        ...config,
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor profile fetch error:", error);
    throw error;
  }
};

const updateVendorProfile = async (data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/profile/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor profile update error:", error);
    throw error;
  }
};

const updatePageAccess = async (id, pageAccess) => {
  try {
    const token = getToken();

    const res = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/profile/page-access/?id=${id}`,
      { page_access: pageAccess },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Page access update error:", error);
    throw error;
  }
};

const updateVendorAvatar = async (avatarFile) => {
  try {
    const token = getToken();

    const formData = new FormData();
    formData.append("avatar", avatarFile);

    const res = await axios.postForm(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/profile/avatar/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res;
  } catch (error) {
    console.error("Vendor avatar update error:", error);
    throw error;
  }
};

const changeVendorPassword = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/profile/change-password/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Password change error:", error);
    throw error;
  }
};

export {
  getRoles,
  getFuelVendorProfile,
  updateVendorProfile,
  updatePageAccess,
  updateVendorAvatar,
  changeVendorPassword,
};
